// extracted by mini-css-extract-plugin
export default {"price":"VhsxX5lWB2JjAYQTsNDbvg==","priceValue":"TnbP1O6CjD1w7kp+4zNUTw==","priceVat":"BMLlOtYm5BeXB7gCyv4yiA=="};